module.exports = {
  currency: {
    SGD: "SGD",
  },
  dateformat: {
    default: "YYYY-MM-DD",
    DMY: "DD-MM-YYYY",
    MDY: "MM-DD-YYYY",
  },
  timezone: "Asia/Singapore",
  sessionTimeout: 1000*60*15
}
